import PropTypes from 'prop-types'
import React from 'react'
import Helmet from 'react-helmet'

import 'typeface-fira-sans'

import '../css/prism.css'
import { rhythm } from '../utils/typography'

const TemplateWrapper = ({ children }) => (
  <div>
    <Helmet
      title="Albert /DEV"
      meta={[
        {
          name: 'description',
          content: `My name is Albert Casanovas and I'm a passionate full-stack developer. I build software for today's users and tomorrow's platforms.`
        }
      ]}
    />
    <div
      css={{
        margin: `0 auto`,
        maxWidth: rhythm(28),
        padding: `0 ${rhythm(1)}`
      }}>
      {children()}
    </div>
  </div>
)

TemplateWrapper.propTypes = {
  children: PropTypes.func
}

export default TemplateWrapper



// WEBPACK FOOTER //
// ./src/layouts/index.js